const store = {
  contact: {
    email: "fm@tyfc.co",
    street: "Heimdalsgade 37B",
    postal_code: "2200",
    city: "Copenhagen N",
    country: "Denmark",
  },
  jobs: [
    // {
    //   title: 'Architect Intern',
    //   pathToAttachment: '/static/job-postings/arch-internship.pdf',
    //   type: 'Full time'
    // }
  ],
};

export default store;



// WEBPACK FOOTER //
// ./src/store.js